import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
export function HeroSection() {
  const scrollToCheckout = () => {
    const checkoutSection = document.getElementById('checkout');
    if (checkoutSection) {
      checkoutSection.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <section className="pt-12 pb-20 px-4 sm:px-6 overflow-hidden relative" data-id="element-30">
      {/* Decorative background elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden -z-10 pointer-events-none" data-id="element-31">
        <div className="absolute top-[-10%] left-[-10%] w-[40%] h-[40%] rounded-full bg-brand-light/40 blur-3xl" data-id="element-32"></div>
        <div className="absolute bottom-[-10%] right-[-10%] w-[50%] h-[50%] rounded-full bg-brand-accent/10 blur-3xl" data-id="element-33"></div>
      </div>

      <div className="max-w-4xl mx-auto text-center" data-id="element-34">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} data-id="element-35">
          <div className="inline-block mb-4 px-4 py-1.5 rounded-full bg-brand-light text-brand-dark font-bold text-sm tracking-wide uppercase" data-id="element-36">
            Para madres ocupadas
          </div>
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-brand-text mb-6 leading-tight text-balance" data-id="element-37">
            El Fin de la Crisis de las 7:00 PM:{' '}
            <span className="text-brand-primary" data-id="element-38">
              El Método Cero Estrés 2-2-2
            </span>
          </h1>
          <h2 className="text-xl md:text-2xl text-brand-text/80 mb-10 font-medium leading-relaxed max-w-3xl mx-auto text-balance" data-id="element-39">
            Recupera 10 horas de tu semana y cocina para toda la familia en solo
            120 minutos (aunque odies planificar).
          </h2>
        </motion.div>

        {/* Product Image */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.15
      }} className="flex justify-center mb-10" data-id="element-40">
          <img src="https://cdn.magicpatterns.com/uploads/ftpc1nmS9TA4BMAL3d4hso/cover.png" alt="Ebook Cero Estrés 2-2-2" className="w-56 md:w-72 rounded-xl shadow-xl" data-id="element-41" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="bg-white p-6 md:p-8 rounded-2xl shadow-lg border border-brand-light/50 text-left mb-10 relative" data-id="element-42">
          <div className="absolute -top-4 -left-4 text-4xl" data-id="element-43">⏰</div>
          <p className="text-lg text-brand-text/90 leading-relaxed mb-4" data-id="element-44">
            <strong data-id="element-45">Son las 6:45 de la tarde.</strong> Abres el refrigerador y
            lo único que ves son ingredientes sueltos y recipientes vacíos.
            Sientes ese nudo en el estómago porque sabes lo que viene: niños con
            hambre, fatiga mental absoluta y la derrota de terminar pidiendo
            comida a domicilio por tercera vez en la semana.
          </p>
          <p className="text-lg text-brand-text/90 leading-relaxed" data-id="element-46">
            No es que no sepas cocinar. Es que estás agotada de decidir. La
            "carga mental" de alimentar a tu familia te está robando la paz, el
            dinero y tu tiempo libre.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.5,
        delay: 0.4
      }} data-id="element-47">
          <Button size="xl" onClick={scrollToCheckout} animate className="w-full sm:w-auto" data-id="element-48">
            ¡SÍ, QUIERO COCINAR EN 2 HORAS!
          </Button>
          <p className="mt-4 text-sm text-brand-text/60 font-medium" data-id="element-49">
            Acceso instantáneo • Garantía de 7 días
          </p>
        </motion.div>
      </div>
    </section>;
}